import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PortalButton } from "@/components/Motion";

export default function NotFound() {
  useEffect(() => { document.title = "Page Not Found | Regal Tuning"; }, []);
  return (
    <main className="grid min-h-[80vh] place-items-center px-5 pt-24" data-testid="not-found-page">
      <div className="text-center">
        <p className="overline-label mb-4">Error 404</p>
        <h1 className="font-display text-4xl sm:text-6xl font-extrabold uppercase tracking-tight text-ink">Page not found</h1>
        <p className="mx-auto mt-5 max-w-md text-base text-neutral-400">
          The page you're looking for doesn't exist or has moved. Try the shop, or head to the File Portal if you're an existing customer.
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <Link to="/" data-testid="not-found-home" className="inline-flex items-center gap-2 bg-regal-amber px-8 py-4 font-display text-sm font-bold uppercase tracking-[0.14em] text-white hover:bg-amber-400 transition-colors">
            Back to Home <ArrowRight size={15} />
          </Link>
          <Link to="/tuning-tools" data-testid="not-found-shop" className="inline-flex items-center gap-2 border border-linebright px-8 py-4 font-display text-sm font-bold uppercase tracking-[0.14em] text-ink hover:border-regal-amber hover:text-regal-amber transition-colors">
            Browse Tools
          </Link>
          <PortalButton label="File Portal" testId="not-found-portal" />
        </div>
      </div>
    </main>
  );
}
